export default __webpack_public_path__ + "static/media/calendar.7c002d63.svg";